import React from 'react'

import { checkInitAssetUrl } from '@common/services'
import useMain from '@hooks/useMain'

import { ContainerTicket, ContainerTicketSuccess, TicketFrame, TicketImage, TicketTag, TicketVideo } from './styles'

interface ITicketProperties {
    assetId?: number
    assetUrl: string
    isThumbnail?: boolean
}

const Ticket: React.FC<ITicketProperties> = ({ assetUrl, isThumbnail = false, assetId }) => {
    const [source, setSource] = React.useState('')
    const [contentType, setContentType] = React.useState('text/html')
    const {
        state: { currentStep },
    } = useMain()

    const renderTicketByType = () => {
        if (contentType.includes('text') || contentType.includes('application')) {
            return <TicketFrame src={source} frameBorder="0" allow="fullscreen" isThumbnail={isThumbnail} />
        }

        if (contentType.includes('video')) {
            return <TicketVideo src={source} controls isThumbnail={isThumbnail} />
        }

        return <TicketImage src={source} alt={source} isThumbnail={isThumbnail} />
    }

    const cleanUpTicket = React.useCallback(() => {
        setSource('')
        setContentType('text/html')
    }, [])

    React.useEffect(() => {
        checkInitAssetUrl(assetUrl, setSource, setContentType)
        return () => cleanUpTicket()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            {currentStep !== 'success' ? (
                <ContainerTicket>
                    {assetId && <TicketTag>#{assetId}</TicketTag>}
                    {renderTicketByType()}
                </ContainerTicket>
            ) : (
                <ContainerTicketSuccess>
                    {assetId && <TicketTag>#{assetId}</TicketTag>}
                    {renderTicketByType()}
                </ContainerTicketSuccess>
            )}
        </>
    )
}

export default Ticket
